/**
 * @file: isEmail.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isEmail(s: string): boolean {
  return Boolean(s && REGEX_EMAIL.test(s));
}
